const URL_MEDIA_LIST = 'media';

export async function getMediaList(params = {}) {
    const response = await axios.get(
        `/api/serverside/getImages`
    );
    return response;
}